/**
 * This file contains the functions to provide pricing
 * 
 * Call getPricing(fabric, productType, shape, meas1, meas2, meas3)
 * 
 * fabtic: 'panama' (currently only panama is supported)
 * productType: 'tablecloth' (currently only tablecloth is supported)
 * shape: 'round' or 'rectangle' (currently only these shapes are supported)
 * 
 */

/**
 * UT request structure
 * --------------------------------
 * 
 * Detailing: irrelevant for pricing
 * Model: irrelevant for pricing
 * Measurement 1: diameter for round, width for rectangular
 * Measurement 2: length for rectangular
 * Measurement 3: height for fitted
 * Option1: 
 * Option2: umbrella hole, not offered by South, so irrelevant for pricing
 * Option3:
 * item: "Tablecloths"
 * itemType: "Panama"
 * itemSubType: "1" -> Round, "2" -> Square, "3" -> Rectangle, "4" -> Oval
 * color: numbered colors, irrelevant for pricing
 * quantity:
 * requestType: getQuote
 */

/**
 * UT response structure
 * -------------------------------- 
 * 
 * cost: total cost of the quote
 * errorStatus: boolean, true if there was an error
 * hash: hash of the quote
 * qty: quantity of the quote
 * tier_pricing: array of objects with the following structure:
 * {
 *  qty1: cost1,
 *  qty2: cost2,
 *  qty3: cost3,
 *  ...
 * }
 * 
 */

var debug = true;
function trace(msg) {
    if (debug)
        console.log('SouthPricing: ' + msg)
}

const SouthPricing = {
    'panama': {
        'round': [
            {
                'size': 70,
                'cost': 28.95
            },
            {
                'size': 84,
                'cost': 30.6
            },
            {
                'size': 90,
                'cost': 28.55
            },
            {
                'size': 96,
                'cost': 34.65
            },
            {
                'size': 102,
                'cost': 36.8
            },
            {
                'size': 108,
                'cost': 38.35
            },
            {
                'size': 114,
                'cost': 47.4
            },
            {
                'size': 120,
                'cost': 44.2
            },
            {
                'size': 132,
                'cost': 56.8
            }
        ],
        'rectangular': 0.0039 // cost per square inch for rectangular tablecloths based on 60x120 costing $27.95
    }
};

function getPanamaPricing(productType, shape, meas1, meas2 = 0, meas3 = 0) {

    var response = {};
    
    // it is panama fabric, check product type
    switch (productType) {

        case 'tablecloths':

            // it is a tablecloth, check the shape
            trace('Tablecloth product type selected');
            switch (shape) {

                case 'round':
                    // round shape, meas1 is the diameter
                    trace('Round shape selected');

                    // get min and max sizes
                    var minSize = SouthPricing.panama.round[0].size;
                    var maxSize = SouthPricing.panama.round[SouthPricing.panama.round.length - 1].size;

                    // return minSize cost if meas1 is less than minSize
                    if (meas1 < minSize) {
                        trace('Minimum diameter for round tablecloth is ' + minSize + ' inches, current diameter: ' + meas1 + ' inches');
                        response = {
                            "errorStatus": false,
                            "message": "Minimum diameter for round tablecloth is " + minSize + " inches, current diameter: " + meas1 + " inches, returing cost for " + minSize + " inches",
                            "cost": SouthPricing.panama.round[0].cost
                        };
                    }

                    // if meas1 is greater than maxSize, return equivalent per inch cost
                    else if (meas1 > maxSize) {
                        trace('Diameter for round tablecloth is greater than ' + maxSize + ' inches, returning equivalent per inch cost');
                        var maxCost = SouthPricing.panama.round[SouthPricing.panama.round.length - 1].cost;
                        var maxArea = Math.PI * Math.pow(maxSize / 2, 2); // area of the largest round tablecloth
                        var costPerInch = maxCost / maxArea; // cost per square inch for the largest round tablecloth
                        var measArea = Math.PI * Math.pow(meas1 / 2, 2); // area of the requested round tablecloth
                        var cost = Math.round(costPerInch * measArea * 100) / 100; // calculate cost for the requested round tablecloth
                        response = {
                            "errorStatus": false,
                            "message": "Diameter for round tablecloth is greater than " + maxSize + " inches, returning equivalent per inch cost",
                            "cost": cost
                        };
                    }

                    else {
                        // find the cost for the requested size
                        trace('Finding cost for round tablecloth with diameter: ' + meas1 + ' inches');

                        // start with the highest cost
                        var cost = maxSize;
                        for (let i = SouthPricing.panama.round.length - 1; i >= 0; i--) {
                            if (SouthPricing.panama.round[i].size < meas1)
                                break;
                            cost = SouthPricing.panama.round[i].cost;
                        }

                        response = {
                            "errorStatus": false,
                            "cost": cost
                        };
                    }

                    break;

                case 'rectangular':
                case 'square':
                case 'oval':

                    // minimum size is 45x45 square, so check if is smaller than that
                    if (shape == 'square')
                        meas2 = meas1; // for square, meas2 is the same as meas1
                    var area = meas1 * meas2; // area in square inches
                    if (area < 2025) { // 45 * 45 = 2025
                        trace('Minimum area for rectangular tablecloth is 2025 square inches, current area: ' + area + ' square inches');
                        response = {
                            "errorStatus": false,
                            "message": "Minimum area for rectangular tablecloth is 2025 square inches, current area: " + area + " square inches, returning cost for 45x45 inches",
                            "cost": SouthPricing.panama.rectangular * 2025
                        };
                    }
                    else {
                        // calculate the cost based on the area
                        trace('Calculating cost for rectangular tablecloth with area: ' + area + ' square inches');
                        var cost = Math.round(SouthPricing.panama.rectangular * area * 100) / 100; // round to 2 decimal places
                        response = {
                            "errorStatus": false,
                            "cost": cost
                        };
                    }

                    break;

                default:
                    response = {
                        "errorStatus": true,
                        "message": "Unsupported shape for tablecloth"
                    };
            }

            break;

        default:
            trace('Unsupported product type: "' + productType + '"');
            response = {
                "errorStatus": true,
                "message": "Unsupported product type '" + productType + "'"
            };
    }

    return response;
    
}

// Main Function, this is the only function that should be called from outside this file.
function getSouthPricing(quoteData) {

    //get parameters from UT structure
    var fabric = quoteData.find(item => item.name === 'itemType')?.value.toLowerCase();
    var productType = quoteData.find(item => item.name === 'item')?.value.toLowerCase();
    var shape = quoteData.find(item => item.name === 'itemSubtype')?.value;
    var hem = quoteData.find(item => item.name === 'Option1')?.value == '1';
    var umbrellaHole = quoteData.find(item => item.name === 'Option2')?.value == '1';

    switch (shape) {
        case '1':
            shape = 'round';
            break;
        case '2':
            shape = 'square';
            break;
        case '3':
            shape = 'rectangular';
            break;
        case '4':
            shape = 'oval';
            break;
    }
    var meas1 = parseInt( quoteData.find(item => item.name === 'Measurement1')?.value );
    var meas2 = parseInt( quoteData.find(item => item.name === 'Measurement2')?.value || 0 ); // default to 0 if not provided
    var meas3 = parseInt( quoteData.find(item => item.name === 'Measurement3')?.value || 0 ); // default to 0 if not provided

    trace('getPricing called with fabric: ' + fabric + ', productType: ' + productType + ', shape: ' + shape + ', meas1: ' + meas1 + ', meas2: ' + meas2 + ', meas3: ' + meas3);

    var data = {};

    switch (fabric) {
        case 'panama':
            trace('Panama fabric selected');
            data = getPanamaPricing(productType, shape, meas1, meas2, meas3);
            break;
        default:
            trace('Unsupported fabric: "' + fabric + '"');
            data = {
                "errorStatus": true,
                "message": "Unsupported fabric '" + fabric + "'"
            };
    }

    // Now we add the markup to the cost
    //////////////////////////////////////////////////

    const markup = {
        'panama': {
            'tablecloths': {
                'round': {  // round panama tablecloth is 60% + 3
                    factor: 1.6,
                    fixed: 3,
                    hem: 1.2,         // hem should be 20% of the final price
                    umbrellaHole: 0,  // umbrella hole is a fixed cost of $7
                    velcro: 19.99     // umbrella hole, slit & velcro velcro is a fixed cost of $19.99
                }, 
                'rectangular': {  // rectangular panama tablecloth is 90% + 5
                    factor: 1.9,
                    fixed: 5,
                    hem: 1.2,         // hem should be 20% of the final price
                    umbrellaHole: 0,  // umbrella hole is a fixed cost of $7
                    velcro: 19.99     // umbrella hole, slit & velcro velcro is a fixed cost of $19.99
                },
                'square': { // square panama tablecloth is 60% + 3
                    factor: 1.6,
                    fixed: 3,
                    hem: 1.2,         // hem should be 20% of the final price
                    umbrellaHole: 0,  // umbrella hole is a fixed cost of $7
                    velcro: 19.99     // umbrella hole, slit & velcro velcro is a fixed cost of $19.99
                },
                'oval': {   // oval panama tablecloth is 120% + 5
                    factor: 2.2,
                    fixed: 5,
                    hem: 1.2,         // hem should be 20% of the final price
                    umbrellaHole: 0,  // umbrella hole is a fixed cost of $7
                    velcro: 19.99     // umbrella hole, slit & velcro velcro is a fixed cost of $19.99
                }
            }
        }
    };
    

    if (!data.errorStatus) {
        console.log('Markup data: ', markup);
        let itemPercentageMarkup = markup[fabric][productType][shape]['factor'];
        let itemFixedMarkup = markup[fabric][productType][shape]['fixed'];
        trace('Original cost: ' + data.cost);
        trace('Applying markup: ' + ((itemPercentageMarkup - 1) * 100) + '% + $' + itemFixedMarkup);
        data.cost = (Math.round(data.cost * itemPercentageMarkup * 100) / 100) + itemFixedMarkup; // round to 2 decimal places
        if (hem) {
            trace('Adding hem cost factor: ' + (data.cost * markup[fabric][productType][shape]['hem']));
            data.cost = Math.round(data.cost * markup[fabric][productType][shape]['hem'] * 100) / 100; // round to 2 decimal places
        }
        if (umbrellaHole) {
            trace('Adding umbrella hole cost fixed: ' + markup[fabric][productType][shape]['umbrellaHole']);
            data.cost += markup[fabric][productType][shape]['umbrellaHole'];
        }
        trace('Final cost: ' + data.cost);
    } else {
        trace('Error in pricing: ' + data.message);
    }

    return data;
}